import React from 'react';
import { Spin } from 'antd';

interface LoadingProps {
  size?: 'small' | 'default' | 'large';
  text?: string;
  className?: string;
}

export const Loading: React.FC<LoadingProps> = ({
  size = 'default',
  text,
  className = ''
}) => {
  return (
    <div className={`loading-container ${className}`}>
      <Spin size={size} />
      {text && <div className="loading-text">{text}</div>}
    </div>
  );
};

// 页面级加载组件
export const PageLoading: React.FC<{ text?: string }> = ({ text }) => {
  return (
    <div className="page-loading">
      <Loading size="large" text={text} />
    </div>
  );
};

// 内联加载组件
export const InlineLoading: React.FC<{ text?: string }> = ({ text }) => {
  return <Loading size="small" text={text} />;
};
